module.exports = __webpack_public_path__ + "assets/sounds/coins.mp3";